<template>
  <div>
    <b-dropdown right menu-class="dropdown-menu-xl p-0" toggle-class="header-item noti-icon" variant="black">
      <template v-slot:button-content>
        <div class="notification-button" :class="{ organization: layout ? layout === 'organization' : '' }">
          <span v-if="unreads.length" class="badge badge-pill badge-info font-size-11" :class="{ ' has-unreaded-badge': unreads.length > 0 }">
            {{ unreads.length > 20 ? "20+" : unreads.length }}
          </span>
          <i class="bx bxs-bell" :class="{ 'bx-tada has-unreaded-icon': unreads.length > 0 }"></i>
        </div>
      </template>

      <div>
        <div class="row align-items-center">
          <div class="card-body pt-0 pb-0">
            <b-tabs v-model="tabIndex" justified nav-class="nav-tabs-custom">
              <b-tab active>
                <template v-slot:title>
                  <h6 class="m-1">{{ $t("notification.your-notifications") }}</h6>
                </template>
                <div class="d-flex flex-row-reverse">
                  <a v-if="unreads.length > 0" href="javacript:;" @click="markAsReadAll()" class="small pt-0 mt-1">
                    <i class="mdi mdi-adjust"></i> {{ $t("notification.mark-as-read-all") }}</a
                  >
                </div>
                <simplebar style="max-height:300px">
                  <empty v-if="unreads.length == 0" width="200px">
                    <h6 class="text-center text-muted">{{ $t("notification.empty") }}</h6>
                  </empty>

                  <div
                    v-for="item in unreads"
                    :key="item._id"
                    :class="{ readed: !item.readed, hand: !item.readed }"
                    @click="markAsRead(item)"
                    class="text-reset notification-item hider"
                  >
                    <div class="media">
                      <div class="avatar-xs mr-3">
                        <span
                          v-if="item.readed"
                          :class="{
                            'bg-soft-danger': item.type == 'ERROR',
                            'bg-soft-primary': item.type == 'INFO',
                            'bg-soft-success': item.type == 'SUCCESS',
                            'bg-soft-warning': item.type == 'WARNING',
                            'bg-soft-info': item.type == 'NEWS',
                          }"
                          class="avatar-title  rounded-circle font-size-16"
                        >
                          <i class="bx bx-bell"></i>
                        </span>
                        <span
                          v-else
                          :class="{
                            'bg-danger': item.type == 'ERROR',
                            'bg-primary': item.type == 'INFO',
                            'bg-success': item.type == 'SUCCESS',
                            'bg-warning': item.type == 'WARNING',
                            'bg-info': item.type == 'NEWS',
                          }"
                          class="avatar-title rounded-circle font-size-16"
                        >
                          <i class="bx bx-bell"></i>
                        </span>
                      </div>

                      <div class="media-body">
                        <i class="bx bx-trash text-danger float-right hand hidden" @click="remove(item)"></i>

                        <h6 class="mt-0 mb-1">{{ item.title | translate }}</h6>
                        <div class="font-size-12 text-muted">
                          <p v-if="item.message" class="mb-1">{{ item.message | translate }}</p>
                          <p class="mb-0">
                            <i class="mdi mdi-clock-outline"></i>
                            {{ item.at | date(true) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </simplebar>

                <div class="p-2 border-top">
                  <a class="btn btn-sm btn-light btn-block text-center" @click="tabIndex++" href="javascript:void(0)">
                    <i class="mdi mdi-arrow-down-circle mr-1"></i>
                    {{ $t("notification.view-all") }}
                  </a>
                </div>
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <h6 class="m-1">{{ $t("notification.all-notifications") }}</h6>
                </template>
                <simplebar style="max-height:500px">
                  <empty v-if="pagination && pagination.docs && pagination.docs.length == 0" width="200px">
                    <h6 class="text-center text-muted">{{ $t("notification.empty") }}</h6>
                  </empty>
                  <div v-if="pagination">
                    <div
                      v-for="item in pagination.docs"
                      :key="item._id"
                      :class="{ readed: !item.readed, hand: !item.readed }"
                      @click="markAsRead(item)"
                      class="text-reset notification-item hider"
                    >
                      <div class="media">
                        <div class="avatar-xs mr-3">
                          <span
                            v-if="item.readed"
                            :class="{
                              'bg-soft-danger': item.type == 'ERROR',
                              'bg-soft-primary': item.type == 'INFO',
                              'bg-soft-success': item.type == 'SUCCESS',
                              'bg-soft-warning': item.type == 'WARNING',
                              'bg-soft-info': item.type == 'NEWS',
                            }"
                            class="avatar-title rounded-circle font-size-16"
                          >
                            <i class="bx bx-bell"></i>
                          </span>
                          <span
                            v-else
                            :class="{
                              'bg-danger': item.type == 'ERROR',
                              'bg-primary': item.type == 'INFO',
                              'bg-success': item.type == 'SUCCESS',
                              'bg-warning': item.type == 'WARNING',
                              'bg-info': item.type == 'NEWS',
                            }"
                            class="avatar-title  rounded-circle font-size-16"
                          >
                            <i class="bx bx-bell"></i>
                          </span>
                        </div>

                        <div class="media-body">
                          <i class="bx bx-trash text-danger float-right hand hidden" @click="remove(item)"></i>

                          <h6 class="mt-0 mb-1">{{ item.title | translate }}</h6>
                          <div class="font-size-12 text-muted">
                            <p v-if="item.message" class="mb-1">{{ item.message | translate }}</p>
                            <p class="mb-0">
                              <i class="mdi mdi-clock-outline"></i>
                              {{ item.at | date(true) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </simplebar>

                <b-pagination
                  v-if="pagination && pagination.docs && pagination.docs.length > 0"
                  @click.native.stop
                  v-model="request.options.page"
                  :total-rows="pagination.totalDocs"
                  :per-page="pagination.limit"
                  size="sm"
                ></b-pagination>
                <div class="p-2 border-top">
                  <a class="btn btn-sm btn-light btn-block text-center" @click="tabIndex--" href="javascript:void(0)">
                    <i class="mdi mdi-arrow-down-circle mr-1"></i>
                    {{ $t("notification.view-latest") }}
                  </a>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import Simplebar from "simplebar-vue";

export default {
  components: { Simplebar },
  props: ["layout"],
  data() {
    return {
      tabIndex: 1,
      request: {
        query: { "scope.value": undefined },
        options: {
          page: 1,
          limit: 20,
          sort: { at: -1 },
        },
      },
    };
  },
  computed: {
    unreads() {
      return this.pagination?.docs?.filter((i) => !i.readed) ?? [];
    },
    pagination() {
      return this.$store.getters["accountNotification/pagination"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },

  mounted() {},
  methods: {
    paginate() {
      this.$store.dispatch("accountNotification/paginate", this.request);
    },
    async remove(item) {
      await this.$store.dispatch("accountNotification/remove", item);
      this.paginate();
    },
    async markAsRead(item) {
      if (item.readed) return;
      await this.$store.dispatch("accountNotification/markAsRead", item);
      this.paginate();
    },
    async markAsReadAll() {
      await this.$store.dispatch("accountNotification/markAsReadAll");
      this.paginate();
    },
  },
};
</script>

<style scoped lang="scss">
.readed {
  background-color: rgb(237 243 249) !important;
}

.pagination {
  justify-content: center;
}

.notification-button i:not(.has-unreaded-icon) {
  color: rgb(200, 200, 200) !important;
}

.notification-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.875rem;
  height: 2.875rem;
  border-radius: 0.625rem;
  border: 1px solid #d0d0d0;
  position: relative;
  transition: background-color, color, 0.3s;

  &.organization {
    border-color: #363d52;
  }

  &:hover {
    background-color: #f5f7f9;
  }
}

.has-unreaded-icon {
  color: #ff7c48 !important;
}

.noti-icon .badge {
  position: absolute;
  top: 0;
  right: 4px;
}

.noti-icon .badge-info {
  background-color: #ff7c48 !important;
}

.noti-icon i {
  font-size: 28px;
}

.has-unreaded-badge {
  margin-right: -3px;
}
</style>
